import { ReservaTipoPagamento } from "core/features/reservas/typings";
import TagStatus from "./TagStatus";

interface FiltroTipoPagamentoProps {
  selectedTipoPagamento?: ReservaTipoPagamento;
  setSelectedTipoPagamento?: (tipo?: ReservaTipoPagamento) => any;
}

function FiltroTagTipoPagamento({
  selectedTipoPagamento,
  setSelectedTipoPagamento,
}: FiltroTipoPagamentoProps) {
  const onSelectTipoStatus = (t: ReservaTipoPagamento) => {
    if (selectedTipoPagamento === t) {
      setSelectedTipoPagamento?.(undefined);
    } else {
      setSelectedTipoPagamento?.(t);
    }
  };

  return (
    <>
      <TagStatus
        onClick={() => onSelectTipoStatus?.(ReservaTipoPagamento.Gratis)}
        selected={selectedTipoPagamento === ReservaTipoPagamento.Gratis}
      >
        Grátis
      </TagStatus>

      <TagStatus
        onClick={() => onSelectTipoStatus?.(ReservaTipoPagamento.Paga)}
        selected={selectedTipoPagamento === ReservaTipoPagamento.Paga}
      >
        Paga
      </TagStatus>
    </>
  );
}

export default FiltroTagTipoPagamento;
